/**
 * USC DPS patrol zone (UPC) — coordinates from official map trace.
 */
export const USC_DPS_POLYGON = [
  { lat: 34.03274113274881, lng: -118.30028096388298 },
  { lat: 34.032770304367126, lng: -118.29156710392724 },
  { lat: 34.036155181836236, lng: -118.29161921041495 },
  { lat: 34.036024223884354, lng: -118.2840581982434 },
  { lat: 34.03984391137915, lng: -118.28413658551652 },
  { lat: 34.03271030591221, lng: -118.26833752064388 },
  { lat: 34.020391850467995, lng: -118.27634850742288 },
  { lat: 34.01973658113454, lng: -118.27503086681584 },
  { lat: 34.0163130867508, lng: -118.27714786419217 },
  { lat: 34.016839472559276, lng: -118.27837829278722 },
  { lat: 34.01364820850833, lng: -118.28036285503734 },
  { lat: 34.01407591065166, lng: -118.28159328363242 },
  { lat: 34.01407591065166, lng: -118.28282371222748 },
  { lat: 34.01118065407074, lng: -118.28278402098246 },
  { lat: 34.0109174440314, lng: -118.29147640363792 },
  { lat: 34.01825411824632, lng: -118.29163516861792 },
  { lat: 34.01820001028973, lng: -118.3002330557233 },
  { lat: 34.03274113274881, lng: -118.30028096388298 },
];
